import { render } from "./ListTravel.vue?vue&type=template&id=0de490cf&scoped=true"
import script from "./ListTravel.vue?vue&type=script&lang=js"
export * from "./ListTravel.vue?vue&type=script&lang=js"

import "./ListTravel.vue?vue&type=style&index=0&id=0de490cf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de490cf"]])

export default __exports__